export default "__VITE_ASSET__3dde1645__"